export { getTerm } from './getTerm';
export type { GetTermParams, GetTermResponse } from './getTerm';
export { getTermConsentPending } from './getTermConsentPending';
export { postTermConsent } from './postTermConsent';
